import { useEffect } from "react";
import { useLocation } from "react-router";
import { buildHireOSURL } from "@shared/hireos-links";

export function HireOSRedirect({ path }: { path: string }) {
  const location = useLocation();
  const target = buildHireOSURL(path, location.search, location.hash);

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <main className="min-h-screen bg-white flex items-center justify-center p-6">
      <a className="font-semibold underline" href={target}>
        Continue to HireOS
      </a>
    </main>
  );
}
